import ProductChangeEditor from './ProductChangeEditor';

export default ProductChangeEditor;
